export const normalizePath = (path: string): string => {
  if (!path) {
    return ''
  }

  let normalized = path.trim()

  if (normalized.length > 1 && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1)
  }

  if (normalized.startsWith('/sales/')) {
    normalized = normalized.replace('/sales', '') || '/'
  }

  return normalized || '/'
}


